import req from "../modules/request.module";

export default {
  async fetchUserCompanies(userId) {
    const res = await req.get(`/companies/users/${userId}`);
    return res.data;
  },
};
